/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Actuator_Warning_2Inputs */



/**
* | output |
* | --- |
* | "Without run feedback, the displayed theoretical state matches the controller command" |
*
* @param {Air_Handler_Unit_Actuator_Warning_2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_actuator_warning_2 = /** @type {((inputs?: Air_Handler_Unit_Actuator_Warning_2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Actuator_Warning_2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Without run feedback, the displayed theoretical state matches the controller command")
	return /** @type {LocalizedString} */ ("En l’absence de retour de marche, l’état théorique affiché correspond à la commande de l’automate")
});